import * as React from 'react'
import { Container } from 'components/Layout'
import { ThreadCreateForm } from '../ThreadCreateForm/ThreadCreateForm.container'

export interface IThreadCreateModalProps {
  modalCancel: () => undefined
  modalConfirm: () => undefined
}
export class ThreadCreateModal extends React.Component<IThreadCreateModalProps> {
  render() {
    const { modalCancel, modalConfirm } = this.props

    return (
      <div>
        <Container paddingTop paddingBottom className="sm">
          <ThreadCreateForm onCancel={modalCancel} onConfirm={modalConfirm} />
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Messages/ThreadCreateModal/ThreadCreateModal.tsx